export enum UploadFileType {
    ROBOT = 'robots',
    OBJECT = 'objects',
    OBJECT_IN_SCENE = 'objects_in_scene',
}
